import { REGIONS } from 'constants/Regions';
const CREATED = {
    code: 0,
    slug: 'created',
    message: 'Created',
    localizationSlug: 'CREATED',
};
const ORDER_ACCEPTED = {
    code: 50,
    slug: 'order_accepted',
    message: 'Order Accepted',
    localizationSlug: 'ORDER_ACCEPTED',
};
const ACCEPTED = {
    code: 60,
    slug: 'accepted',
    message: 'Accepted',
    localizationSlug: 'ACCEPTED',
};
const ETA_PICKUP = {
    code: 62,
    slug: 'eta_pickup',
    message: 'ETA Pickup',
    localizationSlug: 'ETA_PICKUP',
};
const IN_TRANSIT = {
    code: 63,
    slug: 'in_transit',
    message: 'In transit',
    localizationSlug: 'IN_TRANSIT',
};
const ARRIVING_AT_PICKUP = {
    code: 65,
    slug: 'arriving_at_pickup',
    message: 'Arriving at pickup',
    localizationSlug: 'ARRIVING_AT_PICKUP',
};
const ARRIVED_AT_PICKUP = {
    code: 66,
    slug: 'arrived_at_pickup',
    message: 'Arrived at pickup',
    localizationSlug: 'ARRIVED_AT_PICKUP',
};
const PICKED_UP_SHIPMENT = {
    code: 70,
    slug: 'picked_up_shipment',
    message: 'Picked Up',
    localizationSlug: 'PICKED_UP',
};
const ETA_DELIVER = {
    code: 72,
    slug: 'eta_deliver',
    message: 'ETA Deliver',
    localizationSlug: 'ETA_DELIVER',
};
const ARRIVING_AT_DELIVERY = {
    code: 75,
    slug: 'arriving_at_delivery',
    message: 'Arriving at delivery',
    localizationSlug: 'ARRIVING_AT_DELIVERY',
};
const ARRIVED_AT_DELIVERY = {
    code: 76,
    slug: 'arrived_at_delivery',
    message: 'Arrived at delivery',
    localizationSlug: 'ARRIVED_AT_DELIVERY',
};
const DELIVERED = {
    code: 80,
    slug: 'delivered',
    message: 'Delivered',
    localizationSlug: 'DELIVERED',
};
const STOP_WINDOW_CHANGE = {
    code: 100,
    slug: 'stop_window_change',
    message: 'Stop Window Change',
    localizationSlug: 'STOP_WINDOW_CHANGED',
};
const STOP_WINDOW_CONFIRMED = {
    code: 110,
    slug: 'stop_window_confirmed',
    message: 'Stop Window Confirmed',
    localizationSlug: 'STOP_WINDOW_CONFIRMED',
};
const ATTEMPTED_PICKUP = {
    code: 115,
    slug: 'attempted_pickup',
    message: 'Attempted Pickup',
    localizationSlug: 'ATTEMPTED_PICKUP',
};
const ATTEMPED_DELIVERY = {
    code: 116,
    slug: 'attempted_delivery',
    message: 'Attempted Delivery',
    localizationSlug: 'ATTEMPTED_DELIVERY',
};
const INVOICE_CREATED = {
    code: 130,
    slug: 'invoice_created',
    message: 'Invoice Created',
    localizationSlug: 'INVOICE_CREATED',
};
const CREDIT_MEMO_CREATED = {
    code: 131,
    slug: 'credit_memo_created',
    message: 'Credit Memo Created',
    localizationSlug: 'CREDIT_MEMO_CREATED',
};
const EXPORT_ORDER_EQUIPMENT_ADDED = {
    code: 140,
    slug: 'export_order_equipment_added',
    message: 'Export Order Equipment Added', // in case we actually use the message field someday
    localizationSlug: 'EXPORT_ORDER_EQUIPMENT_ADDED',
};
const LOAD_TENDERED = {
    code: 150,
    slug: 'load_tendered',
    message: 'Load Tendered',
    localizationSlug: 'LOAD_TENDERED',
};
const LOAD_CANCELED = {
    code: 160,
    slug: 'load_canceled',
    message: 'Load Canceled',
    localizationSlug: 'LOAD_CANCELED',
};
const LOAD_UPDATED = {
    code: 170,
    slug: 'load_updated',
    message: 'Load Updated',
    localizationSlug: 'LOAD_UPDATED',
};
const PAYOUT_PAID = {
    code: 199,
    slug: 'payout_paid',
    message: 'Payout Paid',
    localizationSlug: 'PAYOUT_PAID',
};
const STACK_POSITION_UPDATED = {
    code: 175,
    slug: 'stack_position_updated',
    message: 'Stack Position Updated',
    localizationSlug: 'STACK_POSITION_UPDATED',
};
const CONTAINER_AVAILABLE = {
    code: 180,
    slug: 'container_available',
    message: 'Container Available',
    localizationSlug: 'CONTAINER_AVAILABLE',
};
const CONTAINER_DISCHARGED = {
    code: 61,
    slug: 'container_discharged',
    message: 'Container Discharged',
    localizationSlug: 'CONTAINER_DISCHARGED',
};
const CARRIER_ACCESSORIAL_PENDING_ADMIN = {
    code: 200,
    slug: 'carrier_accessorial_pending_admin',
    message: 'Carrier Pending Admin',
    localizationSlug: 'CARRIER_ACCESSORIAL_PENDING_ADMIN',
};
const SHIPPER_ACCESSORIAL_PENDING_ADMIN = {
    code: 201,
    slug: 'shipper_accessorial_pending_admin',
    message: 'Shipper Side Pending Admin',
    localizationSlug: 'SHIPPER_ACCESSORIAL_PENDING_ADMIN',
};
const CARRIER_ACCESSORIAL_PENDING_SHIPPER = {
    code: 202,
    slug: 'carrier_accessorial_pending_shipper',
    message: 'Carrier Side Pending Shipper',
    localizationSlug: 'CARRIER_ACCESSORIAL_PENDING_SHIPPER',
};
const SHIPPER_ACCESSORIAL_PENDING_SHIPPER = {
    code: 203,
    slug: 'shipper_accessorial_pending_shipper',
    message: 'Shipper Side Pending Shipper',
    localizationSlug: 'SHIPPER_ACCESSORIAL_PENDING_SHIPPER',
};
const CARRIER_ACCESSORIAL_ACCEPTED = {
    code: 204,
    slug: 'carrier_accessorial_accepted',
    message: 'Carrier Side Accepted',
    localizationSlug: 'CARRIER_ACCESSORIAL_ACCEPTED',
};
const SHIPPER_ACCESSORIAL_ACCEPTED = {
    code: 205,
    slug: 'shipper_accessorial_accepted',
    message: 'Shipper Side Accepted',
    localizationSlug: 'SHIPPER_ACCESSORIAL_ACCEPTED',
};
const CARRIER_ACCESSORIAL_APRROVED = {
    code: 206,
    slug: 'carrier_accessorial_approved',
    message: 'Carrier Side Approved',
    localizationSlug: 'CARRIER_ACCESSORIAL_APRROVED',
};
const SHIPPER_ACCESSORIAL_APPROVED = {
    code: 207,
    slug: 'shipper_accessorial_approved',
    message: 'Shipper Side Approved',
    localizationSlug: 'SHIPPER_ACCESSORIAL_APPROVED',
};
const CARRIER_ACCESSORIAL_DECLINED = {
    code: 208,
    slug: 'carrier_accessorial_declined',
    message: 'Carrier Side Declined',
    localizationSlug: 'CARRIER_ACCESSORIAL_DECLINED',
};
const SHIPPER_ACCESSORIAL_DECLINED = {
    code: 209,
    slug: 'shipper_accessorial_declined',
    message: 'Shipper Side Declined',
    localizationSlug: 'SHIPPER_ACCESSORIAL_DECLINED',
};
const LOADED_ON_RAIL = {
    slug: 'rail_loaded',
    localizationSlug: 'LOADED_ON_RAIL',
};
const DEPARTED_ON_RAIL = {
    slug: 'rail_departed',
    localizationSlug: 'DEPARTED_ON_RAIL',
};
const ARRIVED_AT_RAIL_FACILITY = {
    slug: 'rail_arrived_at_facility',
    localizationSlug: 'ARRIVED_AT_RAIL_FACILITY',
};
const UNLOADED_FROM_RAIL = {
    slug: 'rail_unloaded',
    localizationSlug: 'UNLOADED_FROM_RAIL',
};
const AVAILABLE_AT_RAIL_FACILITY = {
    slug: 'rail_available_at_facility',
    localizationSlug: 'AVAILABLE_AT_RAIL_FACILITY',
};
const FULL_OUTGATED_FROM_RAIL_FACILITY = {
    slug: 'rail_outgated_from_facility',
    localizationSlug: 'FULL_OUTGATED_FROM_RAIL_FACILITY',
};
const RAIL_LAST_FREE_DAY = {
    slug: 'rail_lfd_at_facility',
    localizationSlug: 'RAIL_LAST_FREE_DAY',
};
const RAIL_ETA_FINAL_FACILITY = {
    slug: 'rail_eta_final_facility',
    localizationSlug: 'RAIL_ETA_FINAL_FACILITY',
};
const FULL_INGATED_AT_ORIGIN_RAIL_FACILITY = {
    slug: 'rail_ingated_at_origin_facility',
    localizationSlug: 'FULL_INGATED_AT_ORIGIN_RAIL_FACILITY',
};
const LOADED_ON_RAIL_AT_ORIGIN = {
    slug: 'rail_loaded_at_origin',
    localizationSlug: 'LOADED_ON_RAIL_AT_ORIGIN',
};
const DEPARTED_ON_RAIL_FROM_ORIGIN = {
    slug: 'rail_departed_from_origin',
    localizationSlug: 'DEPARTED_ON_RAIL_FROM_ORIGIN',
};
const ARRIVED_AT_DESTINATION_PORT_RAIL_FACILITY = {
    slug: 'rail_arrived_at_destination_port_facility',
    localizationSlug: 'ARRIVED_AT_DESTINATION_PORT_RAIL_FACILITY',
};
const UNLOADED_FROM_RAIL_AT_DESTINATION_PORT = {
    slug: 'rail_unloaded_at_destination_port',
    localizationSlug: 'UNLOADED_FROM_RAIL_AT_DESTINATION_PORT',
};
const ESTIMATED_ARRIVAL = {
    slug: 'estimated_arrival',
    localizationSlug: 'ESTIMATED_ARRIVAL',
};
const LAST_FREE_DATE = {
    slug: 'last_free_date',
    localizationSlug: 'LAST_FREE_DATE',
};
const EMPTY_READY_FOR_PICKUP = {
    slug: 'empty_ready_for_pickup',
    localizationSlug: 'EMPTY_READY_FOR_PICKUP',
};
const ARRIVAL_DATE = {
    slug: 'arrival_date',
    localizationSlug: 'ARRIVAL_DATE',
};
const OUTGATED_DATE = {
    slug: 'outgated_date',
    localizationSlug: 'OUTGATED_DATE',
};
const EMPTY_RETURNED_DATE = {
    slug: 'empty_returned_date',
    localizationSlug: 'EMPTY_RETURNED_DATE',
};
const POD_UPLOADED = {
    slug: 'proof_of_delivery_uploaded',
    localizationSlug: 'POD_UPLOADED',
};
const PER_DIEM_LFD = { slug: 'per_diem_lfd', localizationSlug: 'PER_DIEM_LFD' };
const EARLIEST_DATE_TO_GET_EMPTY = {
    slug: 'earliest_empty_date',
    localizationSlug: 'EARLIEST_DATE_TO_GET_EMPTY',
};
const DOCUMENT_CUTOFF_DATE = {
    slug: 'document_cutoff_date',
    localizationSlug: 'DOCUMENT_CUTOFF_DATE',
};
const LAST_CUT_DATE = {
    slug: 'last_cut_date',
    localizationSlug: 'LAST_CUT_DATE',
};
const EMPTY_RAIL_BILLING = {
    slug: 'empty_rail_billing',
    localizationSlug: 'EMPTY_RAIL_BILLING',
};
const LOADED_RAIL_BILLING = {
    slug: 'loaded_rail_billing',
    localizationSlug: 'LOADED_RAIL_BILLING',
};
const RAIL_EARLIEST_RETURN_DATE = {
    slug: 'rail_earliest_return',
    localizationSlug: 'RAIL_EARLIEST_RETURN_DATE',
};
const RAIL_CUT_DATE = {
    slug: 'rail_cut_date',
    localizationSlug: 'RAIL_CUT_DATE',
};
const REQUESTED_PICKUP_DATE = {
    slug: 'requested_pickup_date',
    localizationSlug: 'REQUESTED_PICKUP_DATE',
};
const PLANNED_DELIVERY_DATE = {
    slug: 'planned_delivery_date',
    localizationSlug: 'PLANNED_DELIVERY_DATE',
};
const ORIGINAL_DISPATCH_DATE = {
    slug: 'original_dispatch_date',
    localizationSlug: 'ORIGINAL_DISPATCH_DATE',
};
const CURRENT_DISPATCH_DATE = {
    slug: 'current_dispatch_date',
    localizationSlug: 'CURRENT_DISPATCH_DATE',
};
const REQUESTED_DELIVERY_APPOINTMENT = {
    slug: 'requested_delivery_appointment',
    localizationSlug: 'REQUESTED_DELIVERY_APPOINTMENT',
};
const MUST_ARRIVE_BY_DATE = {
    slug: 'must_arrive_by_date',
    localizationSlug: 'MUST_ARRIVE_BY_DATE',
};
const REVIEW_DATE = {
    slug: 'review_date',
    localizationSlug: 'REVIEW_DATE',
};
const ACCOUNTING_REVIEW_DATE = {
    slug: 'accounting_review_date',
    localizationSlug: 'ACCOUNTING_REVIEW_DATE',
};
const ON_HOLD = {
    slug: 'on_hold',
    localizationSlug: 'ON_HOLD',
};
const CHASSIS_IN_GATE = {
    slug: 'chassis_in_gate',
    localizationSlug: 'CHASSIS_IN_GATE',
};
const CHASSIS_OUT_GATE = {
    slug: 'chassis_out_gate',
    localizationSlug: 'CHASSIS_OUT_GATE',
};
const PICKUP_FROM_EXAM_SITE = {
    slug: 'pickup_from_exam_site',
    localizationSlug: 'PICKUP_FROM_EXAM_SITE',
};
const DROPOFF_AT_EXAM_SITE = {
    slug: 'dropoff_at_exam_site',
    localizationSlug: 'DROPOFF_AT_EXAM_SITE',
};
export const invoiceEdEvents = [INVOICE_CREATED, CREDIT_MEMO_CREATED];
export const milestoneEdiEvents = [
    CREATED,
    ORDER_ACCEPTED,
    ACCEPTED,
    ETA_PICKUP,
    IN_TRANSIT,
    ARRIVING_AT_PICKUP,
    ARRIVED_AT_PICKUP,
    ATTEMPTED_PICKUP,
    PICKED_UP_SHIPMENT,
    ETA_DELIVER,
    ARRIVING_AT_DELIVERY,
    ARRIVED_AT_DELIVERY,
    ATTEMPED_DELIVERY,
    DELIVERED,
    STOP_WINDOW_CHANGE,
    STOP_WINDOW_CONFIRMED,
    EXPORT_ORDER_EQUIPMENT_ADDED,
    CONTAINER_AVAILABLE,
    CONTAINER_DISCHARGED,
    STACK_POSITION_UPDATED,
    SHIPPER_ACCESSORIAL_PENDING_ADMIN,
    SHIPPER_ACCESSORIAL_PENDING_SHIPPER,
    SHIPPER_ACCESSORIAL_ACCEPTED,
    SHIPPER_ACCESSORIAL_APPROVED,
    SHIPPER_ACCESSORIAL_DECLINED,
    LOADED_ON_RAIL,
    DEPARTED_ON_RAIL,
    ARRIVED_AT_RAIL_FACILITY,
    UNLOADED_FROM_RAIL,
    AVAILABLE_AT_RAIL_FACILITY,
    FULL_OUTGATED_FROM_RAIL_FACILITY,
    RAIL_LAST_FREE_DAY,
    RAIL_ETA_FINAL_FACILITY,
    FULL_INGATED_AT_ORIGIN_RAIL_FACILITY,
    LOADED_ON_RAIL_AT_ORIGIN,
    DEPARTED_ON_RAIL_FROM_ORIGIN,
    ARRIVED_AT_DESTINATION_PORT_RAIL_FACILITY,
    UNLOADED_FROM_RAIL_AT_DESTINATION_PORT,
    ESTIMATED_ARRIVAL,
    LAST_FREE_DATE,
    EMPTY_READY_FOR_PICKUP,
    ARRIVAL_DATE,
    OUTGATED_DATE,
    EMPTY_RETURNED_DATE,
    POD_UPLOADED,
    PER_DIEM_LFD,
    EARLIEST_DATE_TO_GET_EMPTY,
    DOCUMENT_CUTOFF_DATE,
    LAST_CUT_DATE,
    EMPTY_RAIL_BILLING,
    LOADED_RAIL_BILLING,
    RAIL_EARLIEST_RETURN_DATE,
    RAIL_CUT_DATE,
    REQUESTED_PICKUP_DATE,
    REQUESTED_DELIVERY_APPOINTMENT,
    MUST_ARRIVE_BY_DATE,
    ON_HOLD,
    CHASSIS_IN_GATE,
    CHASSIS_OUT_GATE,
    PICKUP_FROM_EXAM_SITE,
    DROPOFF_AT_EXAM_SITE,
];
export const shipperEdiEvents = [...milestoneEdiEvents, ...invoiceEdEvents];
export const carrierEdiEvents = [
    LOAD_TENDERED,
    LOAD_CANCELED,
    LOAD_UPDATED,
    PAYOUT_PAID,
    CARRIER_ACCESSORIAL_PENDING_ADMIN,
    CARRIER_ACCESSORIAL_PENDING_SHIPPER,
    CARRIER_ACCESSORIAL_ACCEPTED,
    CARRIER_ACCESSORIAL_APRROVED,
    CARRIER_ACCESSORIAL_DECLINED,
];
export const ediEvents = [...shipperEdiEvents, ...carrierEdiEvents];
export const importantShipmentDates = [
    REQUESTED_PICKUP_DATE,
    REQUESTED_DELIVERY_APPOINTMENT,
    PLANNED_DELIVERY_DATE,
    MUST_ARRIVE_BY_DATE,
    REVIEW_DATE,
    CHASSIS_OUT_GATE,
    CHASSIS_IN_GATE,
    DROPOFF_AT_EXAM_SITE,
    PICKUP_FROM_EXAM_SITE,
    ACCOUNTING_REVIEW_DATE,
    ORIGINAL_DISPATCH_DATE,
    CURRENT_DISPATCH_DATE,
];
export const shipmentStatuses = [
    { code: 0, message: 'Created', slug: 'created', localizationSlug: 'CREATED' },
    {
        code: 5,
        message: 'En Route',
        slug: 'en_route',
        localizationSlug: 'EN_ROUTE',
    },
    {
        code: 10,
        message: 'Arrived',
        slug: 'arrived',
        localizationSlug: 'ARRIVED',
    },
    {
        code: 20,
        message: 'Scheduled',
        slug: 'scheduled',
        localizationSlug: 'SCHEDULED',
    },
    {
        code: 40,
        message: 'Exposed',
        slug: 'exposed',
        localizationSlug: 'EXPOSED',
    },
    {
        code: 50,
        message: 'Needs Appt',
        slug: 'needs_appt',
        localizationSlug: 'NEEDS_APPT',
    },
    {
        code: 60,
        message: 'Accepted',
        slug: 'accepted',
        localizationSlug: 'ACCEPTED',
    },
    {
        code: 80,
        message: 'In Progress',
        slug: 'in_progress',
        localizationSlug: 'IN_PROGRESS',
    },
    {
        code: 220,
        message: 'Job Canceled',
        slug: 'job_canceled',
        localizationSlug: 'JOB_CANCELED',
    },
    {
        code: 1300,
        message: 'Job Closed',
        slug: 'job_closed',
        localizationSlug: 'JOB_CLOSED',
    },
];
export const podStatuses = [
    {
        code: 0,
        message: 'Valid',
        slug: 'valid',
        localizationSlug: 'VALID',
    },
    {
        code: 1,
        message: 'Need verification',
        slug: 'need_verification',
        localizationSlug: 'NEED_VERIFICATION',
    },
    {
        code: 2,
        message: 'Missing POD',
        slug: 'missing_pod',
        localizationSlug: 'MISSING_POD',
    },
];
export const shipmentStatusBefore = (this_status, target_status) => {
    const this_code = shipmentStatuses.find((s) => s.slug === this_status).code;
    const target_code = shipmentStatuses.find((s) => s.slug === target_status).code;
    return this_code < target_code;
};
export const shipmentTypes = [
    { name: 'longhaul', localizationSlug: 'LONGHAUL' },
    { name: 'shorthaul', localizationSlug: 'SHORTHAUL' },
    { name: 'drayage', localizationSlug: 'DRAYAGE' },
];
export const headersByFieldNames = [
    {
        code: 0,
        slug: 'shipmentId',
        message: 'Shipment ID',
        isShow: true,
    },
    {
        code: 2,
        slug: 'mgLoadId',
        message: 'MG Load ID',
        isShow: true,
    },
    {
        code: 3,
        slug: 'shipmentReferenceId',
        message: 'Reference ID',
        isShow: true,
    },
    {
        code: 4,
        slug: 'pickupByDate',
        message: 'Pickup',
        isShow: true,
    },
    {
        code: 5,
        slug: 'deliverByDate',
        message: 'Deliver',
        isShow: true,
    },
    {
        code: 6,
        slug: 'shipperName',
        message: 'Shipper',
        isShow: true,
    },
    {
        code: 7,
        slug: 'carrierName',
        message: 'Carrier',
        isShow: true,
    },
    {
        code: 8,
        slug: 'driverName',
        message: 'Driver',
        isShow: true,
    },
    {
        code: 9,
        slug: 'originName',
        message: 'Origin',
        isShow: true,
    },
    {
        code: 10,
        slug: 'destinationName',
        message: 'Destination',
        isShow: true,
    },
    {
        code: 11,
        slug: 'moNumber',
        message: 'MO Number',
        isShow: true,
    },
    {
        code: 12,
        slug: 'houseBillNumber',
        message: 'House Bill Number',
        isShow: true,
    },
    {
        code: 13,
        slug: 'tags',
        message: 'Tags',
        isShow: true,
    },
    {
        code: 14,
        slug: 'shipmentStatus',
        message: 'Status',
        isShow: true,
    },
    {
        code: 15,
        slug: 'shipperTotal',
        message: 'Shipper Cost',
        isShow: true,
    },
    {
        code: 16,
        slug: 'carrierTotal',
        message: 'Carrier Payout',
        isShow: true,
    },
];
export const marketByKeys = {
    LAX: 'LA',
    SFO: 'SF',
    NYC: 'NY',
    CHI: 'CH',
};
export const containerEvents = [
    'EMPTY_OUTGATED',
    'FULL_INGATED',
    'LOADED',
    'VESSEL_DEPARTED',
    'VESSEL_ARRIVED',
    'VESSEL_BERTHED',
    'DISCHARGED',
    'AVAILABLE',
    'FULL_OUTGATED',
    'LOADED_ON_RAIL',
    'DEPARTED_ON_RAIL',
    'ARRIVED_AT_RAIL_FACILITY',
    'UNLOADED_FROM_RAIL',
    'AVAILABLE_AT_RAIL_FACILITY',
    'FULL_OUTGATED_FROM_RAIL_FACILITY',
    'DELIVERED',
    'EMPTY_RETURNED',
];
export const actionMapping = {
    pickup: 'PICKUP',
    deliver: 'DELIVER',
};
export const confidenceStatuses = [100, 75, 50, 25, 0];
export const DRIVER_SEARCH_DISTANCE_OPTIONS = {
    marketplace: {
        [REGIONS.US]: [5, 10, 20, 150, 500],
    },
    driver_suggestions: {
        [REGIONS.US]: [5, 10, 20, 40, 150],
    },
};
